export function inputAutoFocus (e, formRef) {
	return new Promise((resolve) => {
		let input = e.target
		let inputs = this.$refs[formRef].$el.getElementsByTagName('input')
		let num = [].findIndex.call(inputs, item => {
			return input === item
		})
		if (num === inputs.length - 1) {
			resolve()
		} else {
			inputs[num + 1].focus()
		}
	})
}
